import { render, staticRenderFns } from "./LeftColumn.vue?vue&type=template&id=51905376&scoped=true"
import script from "./LeftColumn.vue?vue&type=script&lang=js"
export * from "./LeftColumn.vue?vue&type=script&lang=js"
import style0 from "./LeftColumn.vue?vue&type=style&index=0&id=51905376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51905376",
  null
  
)

export default component.exports